module.exports = __webpack_public_path__ + "img/docs.03cd9881.svg";